export const makeRegex = (
  type: string,
  matchList: string[],
  excludeList: string[]
): RegExp => {
  if (type === 'multistring') {
    const orSeparatedMatchList = matchList.join('|')
    let multiStringRegex = new RegExp(`(${orSeparatedMatchList})\\b`, 'i')

    if (excludeList !== null) {
      const orSeparatedExcludeList = excludeList.join('|')
      multiStringRegex = new RegExp(
        `^(?!.*(${orSeparatedExcludeList})\\b).*(${orSeparatedMatchList})\\b`,
        'i'
      )
    }

    return multiStringRegex
  }
}

export const matcherList = [
  {
    matcher: {
      match: ['Anthem'],
      exclude: null,
    },
    alias: 'Anthem',
    isGrouped: null,
    idToBeHighlighted: null,
  },
  {
    matcher: {
      match: ['BCBS', 'Blue Cross', 'BlueCross', 'Blue Shield', 'BlueShield'],
      exclude: ['Anthem'],
    },
    alias: 'Blue Cross Blue Shield',
    isGrouped: null,
    idToBeHighlighted: null,
  },
]

export const topRatedMatcherList = [
  'Aetna',
  'Cigna',
  'BCBS',
  'Blue Cross',
  'BlueCross',
  'Blue Shield',
  'BlueShield',
  'BlueSheild', // cover a typo
  'Optum',
]
